module.exports = __webpack_public_path__ + "img/BG.23c00b5f.svg";